export default __webpack_public_path__ + "static/media/light.f32b9e3f.svg";